import { render, staticRenderFns } from "./course-guides-map-overlay.vue?vue&type=template&id=4b69e674"
import script from "./course-guides-map-overlay.vue?vue&type=script&lang=js"
export * from "./course-guides-map-overlay.vue?vue&type=script&lang=js"
import style0 from "./course-guides-map-overlay.vue?vue&type=style&index=0&id=4b69e674&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports